export default {
    add_integration_title: "Adicionar integración",
    add_integration_save_integration: "Guardar Integración",
    add_integration_type: "Seleccione la integración a adicionar",
    add_integration_select_manufacturers: "Seleccione los fabricantes",
    add_integration_cerebrumX: "CerebrumX",
    add_integration_diesellaptops: "Diesel Laptops",
    "add_integration_wex-ws" : "WEX-WS",
    add_integration_success_message: "La integración se adiciono satisfactoriamente",
    add_integration_error_message: "La integración no se pudo adicionar",
    add_integration_select_account: "Seleccionar cuenta",
    add_integration_account: "Cuenta",
    add_integration_click_message: "Haga clic en guardar para adicionar la nueva integración",
    add_integration_account_required: "La selección de la cuenta es obligatoria",

}